import { render, staticRenderFns } from "./hazardManagementDetail.vue?vue&type=template&id=65bd1b86&scoped=true&"
import script from "./hazardManagementDetail.vue?vue&type=script&lang=ts&"
export * from "./hazardManagementDetail.vue?vue&type=script&lang=ts&"
import style0 from "./hazardManagementDetail.vue?vue&type=style&index=0&id=65bd1b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bd1b86",
  null
  
)

export default component.exports